import {
  Button,
  CardContent,
  Paper,
  Grid,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  Dialog,
  Box,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { submitAnswerDragDrop, useApi } from "../api/Api";
import DragDropOption from "./DragDropOption";
import QuestionDragDropSolution from "./QuestionDragDropSolution";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import QuestionDescription from "./QuestionDescription";

const QuestionDragDrop = ({
  question,
  fetchQuizStats,
  fetchCurrentQuestion,
}) => {
  const { t } = useTranslation();
  const api = useApi();

  const [openAlert, setOpenAlert] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [correct, setCorrect] = useState();
  const [solution, setSolution] = useState();
  const [changeQuestion, setChangeQuestion] = useState(false);

  const [categories, setCategories] = useState(() => {
    let dict = { Options: [] };
    question["categories"].forEach((catg) => (dict[catg.name] = []));
    question["options"].forEach((option) => dict["Options"].push(option));
    return dict;
  });

  const handleClose = () => {
    setOpenAlert(false);
    setFeedback("");
    if (changeQuestion) fetchCurrentQuestion();
    fetchQuizStats();
  };

  useEffect(() => {
    if (!!feedback) setOpenAlert(true);
  }, [feedback]);

  const submitAnswer = () => {
    console.log(categories);
    submitAnswerDragDrop(api, categories)
      .then((response) => {
        let respData = response["data"];
        setCorrect(respData["correct"]);
        setFeedback(respData["feedback"]);
        setSolution(respData["solution"]);
        setChangeQuestion(respData["change_question"]);
      })
      .catch((error) => console.log(error));
  };

  const handleOnDragEnd = (result, categories, setCategories) => {
    if (!result.destination) return;
    const { source, destination } = result;
    if (source.droppableId === destination.droppableId) {
      // Reordering within a category
      const copiedItems = [...categories[source.droppableId]];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      let newCategories = Object.assign({}, categories);
      newCategories[source.droppableId] = copiedItems;
      setCategories(newCategories);
    } else {
      // Moving to a different category
      const sourceItems = [...categories[source.droppableId]];
      const destItems = [...categories[destination.droppableId]];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      let newCategories = Object.assign({}, categories);
      newCategories[source.droppableId] = sourceItems;
      newCategories[destination.droppableId] = destItems;
      setCategories(newCategories);
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Grid item>
        <Paper elevation={10} sx={{ m: 1 }}>
          <CardContent>
            {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_type")}: {t("drag_and_drop")}</Typography>*/}
            {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_no")} {question["questionid"]}</Typography>*/}
            {/*<Typography variant="h6" sx={{mb: 1}}>Partner: {question["partner"]}</Typography>*/}
            {/*<Typography variant="h6" sx={{mb: 1}}>Category: {question["category"]}</Typography>*/}
            {/*<Typography variant="h6" sx={{mb: 1}}>Partner: {question["subcategory"]}</Typography>*/}
            {question["img"] ? (
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ my: 2 }}
              >
                <img
                  src={question["img"]}
                  style={{ maxHeight: 350, maxWidth: "100%" }}
                  alt={t("question")}
                />
              </Grid>
            ) : (
              <></>
            )}
            <QuestionDescription description={question["description"]} />
            <DragDropContext
              onDragEnd={(result) =>
                handleOnDragEnd(result, categories, setCategories)
              }
            >
              <Grid container xs={12} spacing={1}>
                <Grid item xs={6}>
                  {Object.keys(categories)
                    .filter((catg) => catg === "Options")
                    .map((catg) => (
                      <Droppable droppableId={catg}>
                        {(provided) => (
                          <Box sx={{ minHeight: 100, my: 0.5 }}>
                            <span>{t("options")}</span>
                            <Box id={catg} sx={{ border: 1, borderRadius: 1 }}>
                              <Grid
                                container
                                xs={12}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {categories[catg].map((option, index) => (
                                  <Draggable
                                    key={option.id}
                                    draggableId={option.id.toString()}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <Grid
                                        item
                                        sx={{ mx: 1 }}
                                        xs={12}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        ref={provided.innerRef}
                                      >
                                        <DragDropOption
                                          option={option}
                                          key={option.id}
                                          id={option.id}
                                        />
                                      </Grid>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </Grid>
                            </Box>
                          </Box>
                        )}
                      </Droppable>
                    ))}
                </Grid>
                <Grid item xs={6}>
                  {Object.keys(categories)
                    .filter((catg) => catg !== "Options")
                    .map((catg) => (
                      <Droppable droppableId={catg}>
                        {(provided) => (
                          <Box sx={{ minHeight: 100, my: 0.5 }}>
                            <span>{catg}</span>
                            <Box id={catg} sx={{ border: 1, borderRadius: 1 }}>
                              <Grid
                                container
                                xs={12}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {categories[catg].map((option, index) => (
                                  <Draggable
                                    key={option.id}
                                    draggableId={option.id.toString()}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <Grid
                                        item
                                        sx={{ mx: 1 }}
                                        xs={12}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        ref={provided.innerRef}
                                      >
                                        <DragDropOption
                                          option={option}
                                          key={option.id}
                                          id={option.id}
                                        />
                                      </Grid>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </Grid>
                            </Box>
                          </Box>
                        )}
                      </Droppable>
                    ))}
                </Grid>
              </Grid>
            </DragDropContext>

            <Grid item textAlign="center" sx={{ mt: 2 }}>
              <Button variant="contained" onClick={() => submitAnswer()}>
                {t("submit_answer")}
              </Button>
            </Grid>
          </CardContent>
        </Paper>
      </Grid>
      <Dialog
        open={openAlert}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {correct ? t("correct_answer") : t("incorrect_answer")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {feedback}
            {solution === undefined ? (
              <></>
            ) : (
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6">{t("solution")}</Typography>
                <Grid container>
                  <QuestionDragDropSolution question={solution} />
                </Grid>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("close")}</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default QuestionDragDrop;
